<template>
  <div class="ui items">
    <div class="ui message">
      <i class="search icon"></i>
      <span v-if="busy">正在</span>
      在子目录中搜索：
      <span class="ui tiny teal label">
        {{ search_query }}
      </span>
      -
      {{ entries.length }}个结果
      <div v-if="busy" class="ui active inline tiny loader"></div>
    </div>
    <div>
    </div>
    <table class="ui very basic compact table filelist nowrap">
      <tbody>
        <tr>
          <td class="back">
            <a class="ui tiny button" @click="back">
              <i class="reply icon"></i>
              返回文件夹
            </a>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <EntryRow v-for="e in entries"
                  :space="space" :entry="e"
                  :key="e.obj_id"
                  :checked="e.checked"
                  :hide_checkbox="true"
                  :hide_check_background="true"
                  :show_path="true"
                  readonly="true"
                  @del="$emit('del', e)"
                  @click="$emit('click_entry', e)"
                  @goto="$emit('goto', e)"
                  @download="$emit('download', e)"/>
      </tbody>
    </table>
  </div>
</template>

<script>
import EntryRow from './entry-row.vue'
export default {
  name: 'FileSearch',
  props: ['space', 'path', 'search_query'],
  components: {
    EntryRow,
  },
  data: function () {
    return {
      entries: [],
      busy: false,
      stop: false,
    };
  },
  computed: {
  },
  methods: {
    back() {
      this.stop = true;
      this.$emit('close');
    },
    match_query(q, e) {
      var enl = e.name.toLowerCase();
      return q.filter(t => enl.includes(t)).length;
    },
    async search() {
      this.stop = false;
      this.entries = [];
      this.busy = true;
      var cur = await this.space.fetch(this.path);
      if (!cur) {
        this.show_error("无法搜索：获取目录失败");
        return;
      }
      var queue = [cur];
      var q = this.search_query.toLowerCase().split(' ').filter(x => x.length);
      while (!this.stop && queue.length) {
        cur = queue.shift();
        await cur.populate();
        cur.children.forEach(c => {
          if (this.match_query(q, c)) {
            this.entries.push(c);
          }
          if (c.type == "dir") {
            queue.push(c);
          }
        });
      }
      this.busy = false;
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
.ui.active.loader {
  margin-left: 1rem !important;
}
</style>

